const fetchData = (url) => {
  const fetchDataResponse = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  return fetchDataResponse();
};

export default fetchData;
